/**
 * Auth0 organization invitation links land on the dashboard's Default Login
 * URL (PRE-007) carrying `invitation` and `organization` query params. They
 * must be relayed into the `/authorize` call or Universal Login shows a
 * plain login instead of resuming the accept-invitation flow — the step
 * where a new invitee sets their password (FR-023).
 *
 * Auth0 always sends both together, so a partial pair can't be acted on:
 * there is no correct authorize call to make from just one of them.
 */

export interface InvitationParams {
  invitation: string;
  organization: string;
}

export const getInvitationParams = (search: string): InvitationParams | null => {
  const params = new URLSearchParams(search);
  const invitation = params.get('invitation');
  const organization = params.get('organization');

  if (!invitation || !organization) {
    return null;
  }

  return { invitation, organization };
};
